// Shared drag state for custom pointer-based dragging
// This allows FieldCatalogSidebar and PDFAuthoringEditor to communicate
// without relying on unreliable native HTML5 drag-and-drop

export const dragStateStore = {
  field: null,
  isActive: false,
};
